import type { AgentRecord } from "@/types/api/agent"

/**
 * An agent id reaching the frontend can be the primary key or the customer's
 * own id, and a run, a template, and a launch config each store whichever the
 * caller supplied. Look the primary key up first, then fall back to scanning
 * for the customer id, so every surface resolves the same id the same way.
 */
export function resolveAgent(
  agentId: string,
  agentsById: Record<string, AgentRecord>,
): AgentRecord | undefined {
  return (
    agentsById[agentId] ??
    Object.values(agentsById).find(
      (agent) => agent.customer_agent_id === agentId,
    )
  )
}
